import React, { useState } from "react";
import toast from 'react-simple-toasts';
import ProductCard from "../store/ProductCard";
import { updateCartV2 } from "../apiservices/ApiService";

const Card17Product = ({ card, updateCartValue }) => {

    const [loading, setLoading] = useState(false);

    const productDetailNavigation = (product) => {
        const currentQueryParams = window.location.search;

        // localStorage mein daal raha hoon productId ko
        localStorage.setItem("productId", product.data.productId);
        
        // Redirect kar raha hoon, lekin productId query params se hata diya hai
        window.location.href = `/product_detail_page${currentQueryParams}`;
    };

    const handleAddToCart = async (productId) => {
        setLoading(true);
        try {

            const response = await updateCartV2({ callingFrom: "grid", productsJson: `[{"productId":"${productId}","quantity":"1"}]` });

            if (response != null && response.code == 200) {
                toast("added to cart!", 500);
                updateCartValue(response.data.cart[0].cartItemCount);
            } else if (response != null && response.data != null && response.data.message != null) {
                toast(response.data.message, 500);
            }

        } catch (error) {
            alert("Failed to add product to cart.");
        }
    };

    return (
        <div className="p-2">
            <h2 className="text-lg font-semibold mb-2" style={{ color: "#681517" }}>{card.cardMetaData.title}</h2>
            <div className="relative">
                <div className="flex overflow-x-auto gap-3 scrollbar-hide p-2" style={{ paddingBottom: '5px' }}>
                    {card.cardData.map((product, index) => (
                        <ProductCard
                            product={product}
                            handleAddToCart={handleAddToCart}
                            productDetailNavigation={productDetailNavigation}
                            loading={loading}
                        />
                    ))}
                </div>
            </div>
        </div>
    );
};

export default Card17Product;
